import React from 'react';

// Tuile « contrôle + libellé » : icône (bouton) en haut, libellé texte dessous,
// centré. Alignées sur une seule ligne dans le panel de droite (section ACTIONS)
// pour reprendre le rendu des éléments disponibles du panel de gauche (icône +
// libellé), plus lisible que les tooltips seuls.
const labelStyle = {
  fontSize: 10,
  fontWeight: 500,
  lineHeight: 1.15,
  textAlign: 'center',
  color: 'rgba(11, 34, 57, 0.65)',
  // Filet de sécurité quand les tuiles se serrent (4 actions dans un panel de
  // ~250px) : un libellé plus large que sa tuile se coupe au lieu de déborder
  // sur la voisine.
  overflowWrap: 'break-word',
  hyphens: 'auto',
};

// Les tuiles se partagent la largeur du panel (flex) au lieu d'être figées à
// 62px : à quatre actions (multi-sélection : aligner, grouper, copier,
// supprimer) elles passaient à la ligne, et la section « Actions » tenait sur
// deux rangées.
const LabeledControlRow = ({ control, label }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 4,
      flex: '1 1 0',
      minWidth: 0,
      maxWidth: 62,
    }}
  >
    {control}
    <span style={labelStyle}>{label}</span>
  </div>
);

export default LabeledControlRow;
